// thunk.js

import { loginSuccess, loginfailure, logout } from "./reducer";
import axios from "axios";
import toast from "react-hot-toast";
import _BaseAPIService from "../../../services/_BaseAPIService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const apiUrl = window.APP_CONFIG.api1.baseapi + "/auth/login";
const authUser = getLoggedInUser();
console.log("authUserr", authUser);

export const login = (credentials, history) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(apiUrl, credentials);
      console.log("🚀 ~ login ~ full response:", response);
      const apiResponse = response.data || response; // Handle both wrapped and unwrapped responses
      console.log("🚀 ~ login ~ apiResponse:", apiResponse)

    if (apiResponse?.token) {
      const token = apiResponse.token;
      _BaseAPIService.storeToken(token);
      
      // Decode token to extract user info
      const tokenParts = token.split('.');
      const decodedPayload = JSON.parse(atob(tokenParts[1]));
      console.log("🚀 ~ login ~ decodedPayload:", decodedPayload);
      
      // Build user object with decoded token data
      const user = {
        token: token,
        username: apiResponse.username || decodedPayload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "user",
        role: decodedPayload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "SystemUser",
        apiKey: decodedPayload.ApiKey,
        regDate: apiResponse.regDate,
        associatedRoles: [decodedPayload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]] || []
      };
      
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);

      let savedUsers = JSON.parse(localStorage.getItem("savedUsers")) || [];
      const newUser = {
        user: {
          email: apiResponse.username || "superadmin@example.com",
          roles: [decodedPayload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]] || [],
        },
      };

      const exists = savedUsers.some(
        (item) => item.user.email === newUser.user.email
      );

      if (!exists) {
        savedUsers.push(newUser);
        localStorage.setItem("savedUsers", JSON.stringify(savedUsers));
      }

      dispatch(loginSuccess(user));

      const userRole = decodedPayload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      const isSuperAdmin = userRole === "SuperAdmin";
      const isOrgAdmin = userRole === "OrgAdmin";

      // if (isSuperAdmin || isOrgAdmin) {
        history("/dashboard");
      // } else {
      //   history("/pos");
      // }

      toast.success("Welcome to Ordering system");
    } else {
      dispatch(loginfailure());
      toast.error("Invalid response from server. Please try again.");
    }
  } catch (error) {
    console.error(error);
    dispatch(loginfailure());
    toast.error("Invalid username or password. Please try again.");
  }
};
};

export const logoutUser = () => (dispatch) => {
  // Clear the user data and token from local storage.
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("lastCalendarView");

  // Dispatch the logout action.
  dispatch(logout());
};
